<template>
  <div class="box">
    <div class="columns">
      <div class="column is-6">
        <sc-field
          label="Gostaria de esconder os valores duplicados"
          prop="duplicates"
        >
          <sc-switch v-model="quotingReturns.duplicates"> Sim </sc-switch>
        </sc-field>
      </div>
    </div>
    <div>
      <sc-field label="Escolha o tipo de API">
        <div>
          <sc-radio
            v-for="types in returnAPITypes"
            :key="types.id"
            v-model="returnAPIType"
            :native-value="types.id"
          >
            {{ types.description }}
          </sc-radio>
        </div>
      </sc-field>
    </div>
    <sc-quoting-return-tbl-custom-condition
      :quoting-data="config_list"
      :mode-type="returnAPIType"
      :showDetails="true"
      :default-config-item="defaultConfigItem"
      :type-id="typeId"
      @getconfiglistevt="getConfigList"
    >
    </sc-quoting-return-tbl-custom-condition>
  </div>
</template>

<script>
  import { Lodash, Auth } from '@intelipost-js/secure-providers';
  import { createNamespacedHelpers } from 'vuex';
  import {
    ScButton,
    ScField,
    ScSelect,
    ScSwitch,
    ScTableColumn,
    ScRadio,
  } from '@intelipost-js/secure-components';
  import ScQuotingReturnTblCustomCondition from '../sc-quoting-return-tbl-custom-condition/ScQuotingReturnTblCustomCondition.vue';
  import EnumReturnAPIType from '../../enum/EnumReturnAPIType.js';

  const { mapState, mapActions } = createNamespacedHelpers('quote/quotingReturn');
  export default {
    name: 'sc-quoting-return-custom-condition',
    props: {
      returnModeType: {
        type: String,
        required: true,
      },
      typeId: {
        type: Number,
        required: true,
      },
    },
    data() {
      return {
        returnAPIType: 'NORMAL',
        defaultConfigItem: {
          condition: {
            value: '',
          },
          default_new_custom_condition_parameter: {
            param_type: 'MAX_DIFFERENCE_BETWEEN_PROVIDER_SHIPPING_COST',
            value: '0',
          },
          mode_type: null,
          custom_condition_parameters: [],
          actions: [],
          status: false,
          name: '',
          priority: 0,
          order: 0,
        },
      };
    },
    computed: {
      ...mapState([
        'quotingReturns',
      ]),
      config_list() {
        return this.quotingReturns.type_id === this.typeId ? this.quotingReturns.config_list : [];
      },
      returnAPITypes() {
        return EnumReturnAPIType;
      },
    },
    methods: {
      ...mapActions([
        'updateQuotingReturnsCustomCondition',
        'getQuotingReturns',
      ]),
      getConfigList(configList) {
        this.updateQuotingReturnsCustomCondition(
          {
            production: Auth.getUser().is_production,
            returnModeType: this.returnModeType,
            typeId: this.typeId,
            quotingReturns: Lodash.cloneDeep(this.quotingReturns),
            configList,
          },
        );
      },
    },
    components: {
      ScButton,
      ScField,
      ScSelect,
      ScSwitch,
      ScTableColumn,
      ScQuotingReturnTblCustomCondition,
      ScRadio,
    },
  };
</script>



// WEBPACK FOOTER //
// node_modules/@intelipost-modules/secure-quote/features/quoting-return/components/sc-quoting-return-custom-condition/ScQuotingReturnCustomCondition.vue?800b21c8